module.exports = __webpack_public_path__ + "imgs/leaf411-hero.e96da0117b4656d2a552c193d6d68e18.svg";